import React from 'react';
import { 
  Box, 
  Heading, 
  Text, 
  VStack, 
  Container,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Divider
} from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import ClientManagement from '../../components/ClientManagement';

const ClientsPage = () => {
  return (
      <VStack spacing={6} align="stretch">
        {/* Client Management Component */}
        <ClientManagement />
      </VStack>
  );
};

export default ClientsPage;
